/** @format */

import React, { useRef, useState } from 'react';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import GridItem from '../../../components/Grid/GridItem';
import { Button, makeStyles, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, List, ListItem, ListItemText } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import CustomTextButton from '../../../components/Buttons/CustomTextButton';
import Loader from '../../../components/Loaders/Loader';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { apiCall } from '../../../core/apiCall';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';
import { Auth } from '../../../modules/auth/Auth';
import COLORS from '../../../assets/themes/OPL/colors';
import { NotificationHelper } from '../../../helpers/NotificationHelper';

const useStyle = makeStyles(adescomStyle);

interface UploadServiceFileInterface {
    reload: boolean;
    setReload: (reload: boolean) => void;
}

const FileImportServiceList: React.FC<UploadServiceFileInterface> = (props) => {
    const { reload, setReload } = props;
    const dispatch = useDispatch();
    const classes = useStyle();

    const [hideUpload, setHideUpload] = useState<boolean>(true);
    const [visibleLoader, setVisibleLoader] = useState<boolean>(false);
    const [file, setFile] = useState<File | null>(null);
    const [errors, setErrors] = useState<string[]>([]);
    const [openErrorDialog, setOpenErrorDialog] = useState<boolean>(false);

    const selectFile = (event: any): void => {
        const file = event.target.files[0];
        setFile(file);
        setHideUpload(false);
    };


    const upload = (): void => {
        if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('platformUserId', Auth.getUserId().toString());
            setVisibleLoader(true);
            apiCall
                .uploadFile(FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/service_list_uploads')), data)
                .then((response: any): void => {
                    setFile(null);
                    setHideUpload(true);
                    setReload(true);
                    NotificationHelper.notifySuccess('prov:messages.csv_added', dispatch);
                })
                .catch((error: any): void => {
                    if (error.response && error.response.data && error.response.data['hydra:description']) {
                        try {
                            const errorDescriptions = JSON.parse(error.response.data['hydra:description']);
                            setErrors(errorDescriptions);
                        } catch (e) {
                            NotificationHelper.notifyError('prov:messages.csv_error', dispatch);                        }
                    } else {
                        NotificationHelper.notifyError('prov:messages.csv_error', dispatch);
                    }
                    setOpenErrorDialog(true);
                })
                .finally(() => {
                    setVisibleLoader(false);
                });
        }
    };

    const handleCloseErrorDialog = ():void => {
        setOpenErrorDialog(false);
    };

    return (
        <Card>
            <CardBody>
                <GridItem xs={12} style={{ padding: '0.2em' }}>
                    <label htmlFor="btn-upload">
                        <input
                            id="btn-upload"
                            name="btn-upload"
                            style={{ display: 'none' }}
                            type="file"
                            onChange={selectFile}
                            accept="text/csv, .csv"
                        />
                        <Button
                            className={`${classes.button} ${classes.md}`}
                            style={{ backgroundColor: COLORS.MAIN.PRIMARY, height: 50 }}
                            component="span"
                        >
                            <I18n trans="prov:b.choose_file" />
                        </Button>
                    </label>
                    {!hideUpload && (
                        <CustomTextButton
                            size={'lg'}
                            color={'primary'}
                            label={'prov:b.upload_file'}
                            callback={upload}
                            callbackParam={{}}
                        />
                    )}
                </GridItem>
                <Loader visible={visibleLoader} />
                <Dialog
                    open={openErrorDialog}
                    onClose={handleCloseErrorDialog}
                    aria-labelledby="error-dialog-title"
                >
                    <DialogTitle id="error-dialog-title"></DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <I18n trans="prov:b.error_list" />
                        </DialogContentText>
                        <List>
                            {errors.map((error, index) => (
                                <ListItem key={index}>
                                    <ListItemText primary={error} />
                                </ListItem>
                            ))}
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseErrorDialog} color="primary">
                            <I18n trans="general:common.close" />
                        </Button>
                    </DialogActions>
                </Dialog>
            </CardBody>
        </Card>
    );
};

export default FileImportServiceList;
